import { useEffect, useState } from 'react';
import { listDocumentCourse, createDocumentCourse, deleteDocumentCourse } from 'Api/editCourseDocumentPage';
import { s3 } from 'Services/AWS/s3';

const useFetch = ({ courseId, setOpen, setOpenModal }) => {
  const [documents, setDocuments] = useState([]);

  const fetchDocuments = async () => {
    const docs = await listDocumentCourse(courseId);

    setDocuments(docs);
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchDocuments();
    }

    return () => {
      isMounted = false;
      setDocuments([]);
    };
  }, []);

  const createDocument = async (name, mb, url) => {
    const newDocument = await createDocumentCourse(courseId, name, mb, url).catch(err => {
      // eslint-disable-next-line no-console
      console.log(err);
    });

    setDocuments([...documents, newDocument]);
  };

  const deleteDocument = async (id, url) => {
    const success = await s3.deleteObject(url);
    if (success) {
      setDocuments(documents.filter(doc => doc.id !== id));
      await deleteDocumentCourse(id);
    }
    setOpenModal(false);
    setOpen(true);
  };

  return { documents, setDocuments, createDocument, deleteDocument };
};

export default useFetch;
